// Existing production raid_entity_renewed columns; no parallel copy of combat stats.
export const entityStats = [
  {
    key: "stat_str",
    name: "힘",
  },
  {
    key: "stat_dex",
    name: "민첩",
  },
  {
    key: "stat_vit",
    name: "체력",
  },
  {
    key: "stat_int",
    name: "지능",
  },
  {
    key: "stat_foc",
    name: "집중",
  },
  {
    key: "stat_wiz",
    name: "지혜",
  },
  {
    key: "stat_physic_base_power",
    name: "물리 공격력",
  },
  {
    key: "stat_magic_attack_power",
    name: "마법 공격력",
  },
  {
    key: "stat_physic_attack_prof",
    name: "물리 공격 숙련",
  },
  {
    key: "stat_magic_spell_prof",
    name: "마법 시전 숙련",
  },
  {
    key: "stat_physic_block_prof",
    name: "막기 숙련",
  },
  {
    key: "stat_physic_dodge_prof",
    name: "회피 숙련",
  },
  {
    key: "stat_magic_resist_prof",
    name: "마법 저항 숙련",
  },
  {
    key: "stat_physic_armor",
    name: "물리 방어",
  },
  {
    key: "stat_magic_armor",
    name: "마법 방어",
  },
  {
    key: "stat_fire_armor",
    name: "화염 방어",
  },
  {
    key: "stat_frost_armor",
    name: "냉기 방어",
  },
  {
    key: "stat_poison_armor",
    name: "독 방어",
  },
  {
    key: "stat_shadow_armor",
    name: "암흑 방어",
  },
  {
    key: "stat_electr_armor",
    name: "전기 방어",
  },
] as const;
